import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { http } from "@/utils/http"
import { AxiosResponse } from "axios"
import {
  GET_ADD_INVOICE_URL,
  GET_UPDATE_DELETE_INVOICE_URL,
} from "@/constants/api/endpoints"
import {
  InvoiceFormType,
  InvoiceType,
} from "@/types/InvoicesType"


// Todo review the response from the update an the create function
interface FetchInvoicesParams {
  type?: string;
  start_date?: string;
  end_date?: string;
}
// Fetch all invoices
export const fetchInvoices = createAsyncThunk("invoice/fetchInvoices", async (params:FetchInvoicesParams, thunkApi) => {
  return http
    .get<InvoiceType[]>(GET_ADD_INVOICE_URL, {params})
    .then((res): InvoiceType[] => res.data?.results)
    .catch(e => {
      return thunkApi.rejectWithValue({ data: e.data })
    })
})

// Create a invoice
export const createAsyncInvoice = createAsyncThunk<InvoiceType, InvoiceFormType>(
  "invoice/createAsyncInvoice",
  async (invoice: Partial<InvoiceFormType>, thunkApi) => {
    return http
      .post<InvoiceType>(GET_ADD_INVOICE_URL, invoice)
      .then((res): InvoiceType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Update an existing invoice
export const updateAsyncInvoice = createAsyncThunk<InvoiceType, {
  id?: string,
  data?: Partial<InvoiceFormType | FormData>,
}>(
  "invoice/updateAsyncInvoice",
  async ({ id, data }: {
    id?: string,
    data?: Partial<InvoiceFormType | FormData>,
  }, thunkApi) => {
    return http
      .patch<InvoiceType>(GET_UPDATE_DELETE_INVOICE_URL.replace(":id", `${id}`), data)
      .then((res): InvoiceType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Delete an existing invoice
export const deleteAsyncInvoice = createAsyncThunk<AxiosResponse, { id: string }>(
  "invoice/deleteAsyncInvoice",
  async ({ id }: { id: string }, thunkApi) => {
    return http
      .delete<AxiosResponse>(GET_UPDATE_DELETE_INVOICE_URL.replace(":id", id))
      .then(res => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// initial state
const initialState: {
  invoices: InvoiceType[],
  invoicesStatus: string,
  invoicesErrors?: any,

  addInvoiceStatus: string,
  addInvoiceErrors?: any,

  deleteInvoiceErrors?: any,
  deleteInvoiceStatus: string,
} = {
  invoices: [],
  invoicesStatus: "idle",
  addInvoiceStatus: "idle",
  deleteInvoiceStatus: "idle",
}

const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {},

  extraReducers(builder) {
    // get  all invoices
    builder
      .addCase(fetchInvoices.pending, (state) => {
        state.invoicesStatus = "loading"
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.invoicesStatus = "succeeded"
        state.invoices = action.payload
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.invoicesStatus = "failed"
        state.invoicesErrors = action.error
      })

    builder
      .addCase(createAsyncInvoice.pending, (state) => {
        state.addInvoiceStatus = "loading"
      })
      .addCase(createAsyncInvoice.fulfilled, (state, action) => {
        state.addInvoiceStatus = "succeeded"
        state.invoices = [...state.invoices, action.payload]

      })
      .addCase(createAsyncInvoice.rejected, (state, action) => {
        state.addInvoiceStatus = "failed"
        state.addInvoiceErrors = action.error
      })

    builder
      .addCase(updateAsyncInvoice.pending, (state) => {
        state.invoicesStatus = "loading"
      })
      .addCase(updateAsyncInvoice.fulfilled, (state, action) => {
        state.invoicesStatus = "succeeded"
        let index = state.invoices.findIndex(invoice => invoice.id === action.meta.arg.id)
        state.invoices[index] = action.payload
        // if (index >= 0) {
        //   state.invoices.splice(index, 1)
        //   state.invoices.reverse()
        //   state.invoices.unshift(action.payload)
        //   state.invoices.reverse()
        // }

      })
      .addCase(updateAsyncInvoice.rejected, (state, action) => {
        state.invoicesStatus = "failed"
        state.invoicesErrors = action.error
      })

    builder
      .addCase(deleteAsyncInvoice.pending, (state) => {
        state.deleteInvoiceStatus = "loading"
      })
      .addCase(deleteAsyncInvoice.fulfilled, (state, action) => {
        state.invoicesStatus = "succeeded"
        state.invoices = state.invoices.filter((invoice) => invoice.id !== action.meta.arg.id)
      })
      .addCase(deleteAsyncInvoice.rejected, (state, action) => {
        state.deleteInvoiceStatus = "failed"
        state.deleteInvoiceErrors = action.error
      })

  },
})

export default invoicesSlice.reducer

5